
let baseDomainChanges = window.location.origin;

// Stage server
 if (baseDomainChanges === "https://hcpstage.clearancekommerce.com") {
    module.exports = {
        baseUrl: function () {
            return "https://irap-uat.flywheelstaging.com/wp-json/irap/v1";
        },
    };
}
// uat server
else if (baseDomainChanges === "https://hcp-uat.clearancekommerce.com") {
    module.exports = {
        baseUrl: function () {
            return "https://irap-uat.flywheelsites.com/wp-json/irap/v1";
        },
    };
}
// pre go live server
 else if (baseDomainChanges === "https://irap-pre-prod.clearancekommerce.com") {
    module.exports = {
        baseUrl: function () {
            return "https://ornery-country.flywheelstaging.com/wp-json/irap/v1";
        },
    };
}
 else if (baseDomainChanges === "https://irap-stage.healthcraftproducts.com") {
    module.exports = {
        baseUrl: function () {
            return "https://hcp-stage.healthcraftproducts.com/wp-json/irap/v1";
        },
    };
}

 else if (baseDomainChanges === "https://irap-uat.healthcraftproducts.com") {
    module.exports = {
        baseUrl: function () {
            return "https://hcp-uat.healthcraftproducts.com/wp-json/irap/v1";
        },
    };
}

else if (baseDomainChanges === "https://irap-preprod.healthcraftproducts.com") {
    module.exports = {
        baseUrl: function () {
            return "https://hcp-preprod.healthcraftproducts.com/wp-json/irap/v1";
        },
    };
}


// Demo server
else if (baseDomainChanges === "https://irap.clearancekommerce.com") {
    module.exports = {
        baseUrl: function () {
            return "https://stagingjan2024.healthcraftproducts.com/wp-json/irap/v1";
        },
    };
}


// live server
else if (baseDomainChanges === "https://fps.healthcraftproducts.com") {
    module.exports = {
        baseUrl: function () {
            return "https://healthcraftproducts.com/wp-json/irap/v1";
        },
    };
}

else if (baseDomainChanges === "https://irap-stage-v1.healthcraftproducts.com") {
    module.exports = {
        baseUrl: function () {
            return "https://hcp-stage.healthcraftproducts.com/wp-json/irap/v1";
        },
    };
}

else if (baseDomainChanges === "https://irap-uat-v1.healthcraftproducts.com") {
    module.exports = {
        baseUrl: function () {
            return "https://hcp-uat.healthcraftproducts.com/wp-json/irap/v1";
        },
    };
}

else if (baseDomainChanges === "https://irap-preprod-v1.healthcraftproducts.com") {
    module.exports = {
        baseUrl: function () {
            return "https://hcp-preprod.healthcraftproducts.com/wp-json/irap/v1";
        },
    };
}

else if (baseDomainChanges === "https://irap-stage-v2.healthcraftproducts.com") {
    module.exports = {
        baseUrl: function () {
            return "https://hcp-stage.healthcraftproducts.com/wp-json/irap/v1";
        },
    };
}

else if (baseDomainChanges === "https://irap-uat-v2.healthcraftproducts.com") {
    module.exports = {
        baseUrl: function () {
            return "https://hcp-uat.healthcraftproducts.com/wp-json/irap/v1";
        },
    };
}

else if (baseDomainChanges === "https://irap-preprod-v2.healthcraftproducts.com") {
    module.exports = {
        baseUrl: function () {
            return "https://hcp-preprod.healthcraftproducts.com/wp-json/irap/v1";
        },
    };
}


// local server for development
else if (baseDomainChanges === "http://localhost:3000") {
    module.exports = {
        baseUrl: function () {
            return "https://hcp-stage.healthcraftproducts.com/wp-json/irap/v1";
        },
    };
}
else {
    module.exports = {
        baseUrl: function () {
            return `${baseDomainChanges}/wp-json/irap/v1`;
        },
    };
}
